import type { Filters } from '@/domain';
import { BrokerFilter } from './components/brokerFilter/BrokerFilter';
import { CheckboxFilter } from './components/checkboxFilter/CheckboxFilter';
import { FilterGroup } from './components/filterGroup/FilterGroup';
import { HouseRulesFilter } from './components/houseRulesFilter/HouseRulesFilter';
import { PriceFilter } from './components/priceFilter/PriceFilter';
import { PropertyTypeFilter } from './components/propertyTypeFilter/PropertyTypeFilter';
import { TransactionalFilter } from './components/transactionalFilter/TransactionalFilter';

export type FilterProps = {
    filters: Filters;
    onFilterChanged: (filters: Filters) => void;
};
type FilterAndDataProps = FilterProps & {
    filterData: Record<string, unknown>;
};

const mapItems = (items: string[] = []): string[] => (Array.isArray(items) ? items : [items]);

export const Filter = ({ filterData, filters, onFilterChanged }: FilterAndDataProps) => (
    <section data-testid="filters" aria-label="Filtre">
        <FilterGroup title="Utleier" borderTop={false}>
            <BrokerFilter filters={filters} onFilterChanged={onFilterChanged} />
        </FilterGroup>
        {(!Object.hasOwn(filters, 'country') || filters.country === 'Norge') && (
            <FilterGroup title="Bestilling og betaling">
                <TransactionalFilter filters={filters} onFilterChanged={onFilterChanged} />
            </FilterGroup>
        )}
        <FilterGroup title="Pris" data-testid="FilterGroup-pris">
            <PriceFilter filters={filters} onFilterChanged={onFilterChanged} />
        </FilterGroup>
        <FilterGroup title="Boligtype" expanded={false}>
            <PropertyTypeFilter propertyTypes={mapItems(filters.property_types)} onFilterChanged={onFilterChanged} />
        </FilterGroup>
        <FilterGroup title="Husregler og tilgjengelighet" expanded={false}>
            <HouseRulesFilter filters={filters} onFilterChanged={onFilterChanged} />
        </FilterGroup>
        <FilterGroup title="Fasiliteter" expanded={false}>
            <CheckboxFilter
                onFilterChanged={onFilterChanged}
                filterData={filterData.facilities as string[]}
                filterValues={mapItems(filters.facilities)}
                filterType="facilities"
            />
        </FilterGroup>
        <FilterGroup title="I nærheten av" expanded={false}>
            <CheckboxFilter
                onFilterChanged={onFilterChanged}
                filterData={filterData.pois_nearby as string[]}
                filterValues={mapItems(filters.pois_nearby)}
                filterType="pois_nearby"
            />
        </FilterGroup>
    </section>
);
